import React, { useMemo } from 'react';
import {
	Collapse,
	Empty,
} from 'antd';
import { useQuery } from 'react-query';
import {
	BankAccountTypes,
	VesselOwnershipTypes,
} from '@shared/utils/constants';
import { groupByProperty } from '@shared/utils/array';
import VesselOurBankAccounts from '@client/screens/fleet/VesselDetailsScreen/components/VesselOurBankAccounts';
import {
	getOrgBankAccounts,
	getVessels,
} from '@client/lib/api';

const VesselsBank = () => {
	const { data: vessels } = useQuery(['vessels'], () => getVessels());
	const { data: bankAccounts, refetch: refreshBankAccounts } = useQuery(
		['orgBankAccounts', false],
		() => getOrgBankAccounts(false),
	);

	const ownedVessels = useMemo(() => (vessels ?? [])
		.filter((v) => v.ownershipType === VesselOwnershipTypes.OWNED)
		.sort((a, b) => a.name.localeCompare(b.name)), [vessels]);

	const bankAccountsByVessel = useMemo(() => groupByProperty(
		(bankAccounts ?? [])
			.filter((a) => a.vesselId != null && a.type === BankAccountTypes.OURS)
			.sort((a, b) => a.id - b.id),
		(a) => String(a.vesselId),
	), [bankAccounts]);

	if (vessels != null && ownedVessels.length === 0) {
		return (<Empty description="No owned vessels" />);
	}

	return (
		<Collapse
			items={ownedVessels.map((vessel) => ({
				key: vessel.id,
				label: vessel.name,
				children: (
					<VesselOurBankAccounts
						vesselId={vessel.id}
						bankAccounts={bankAccountsByVessel[vessel.id] ?? []}
						onChange={refreshBankAccounts}
						title="Banking Details"
					/>
				),
			}))}
		/>
	);
};

export default VesselsBank;
